
/**
 * 设置地球自转
 * 2021/06/30
 */
var previousTime
var _viewer = null
/**
 * 开始自转
 * @param {Number} rotationSpeed  自转速率 默认10
 * @param {*} self 类本身
 */
function beginEarthRotation (rotationSpeed, self) {
  if (self.isEarthRotation) {
    stopEarthRotation(self)
  }
  self.isEarthRotation = true
  _viewer = self.viewer
  // _viewer._cesiumWidget._creditContainer.style.display = 'none'
  // 速度
  _viewer.clock.multiplier = rotationSpeed || 10
  _viewer.clock.shouldAnimate = true
  previousTime = _viewer.clock.currentTime.secondsOfDay

  self.onTickCallback = onTickCallback
  _viewer.clock.onTick.addEventListener(onTickCallback)
  return true
}

function onTickCallback () {
  var spinRate = 1
  var currentTime = _viewer.clock.currentTime.secondsOfDay
  var delta = (currentTime - previousTime) / 1000
  previousTime = currentTime
  _viewer.scene.camera.rotate(Cesium.Cartesian3.UNIT_Z, -spinRate * delta)
}

/**
 * 结束自转函数
 * @param {*} self 类本身
 * @returns 停止是否成功
 */
function stopEarthRotation (self) {
  if (!self.isEarthRotation) {
    return false
  }
  const _viewer = self.viewer
  const _onTickCallback = self.onTickCallback
  _viewer.clock.shouldAnimate = false
  _viewer.clock.onTick.removeEventListener(_onTickCallback)
  self.isEarthRotation = false
  self.onTickCallback = null
  return true
}

export { beginEarthRotation, stopEarthRotation }
